import { FC } from 'react'

import { ErrorHandler } from 'components'
import { makeTraceDetails } from 'common'
import { ProductBrSkeleton } from 'components/product-br-skeleton'

import { useProductBr } from '../hooks/useProductBr'
import { useBrazilianMeansOfCommunicationAdapter } from './means-of-communication/hooks'
import { Product } from './Product'

export const ProductBr: FC = () => {
  const { screenStatus, isActive, purpose, entity, productContent } = useProductBr()
  const communications = useBrazilianMeansOfCommunicationAdapter({
    communications: productContent?.marketingNotificationsSection.communications ?? {},
    purpose,
  })

  if (screenStatus === 'loading') {
    return (
      <Product
        screen={{
          status: 'loading',
          fallback: (
            <ProductBrSkeleton
              transactionalNotificationsSection={productContent?.transactionalNotificationsSection}
            />
          ),
        }}
      />
    )
  }

  if (
    screenStatus === 'error' ||
    productContent === undefined ||
    purpose === undefined ||
    entity === undefined
  ) {
    const traceDetails = makeTraceDetails(isActive, productContent)

    return (
      <Product
        screen={{
          status: 'error',
          fallback: <ErrorHandler traceDetails={traceDetails} componentName={Product.name} />,
        }}
      />
    )
  }

  return (
    <Product
      screen={{
        status: 'ready',
        productContent,
        communications,
      }}
    />
  )
}
